<template>       
  <div>
      <div v-if="amazonURL" class="disclaimer mx-2 mb-3">Below link(s) lead to our Amazon listing. We may make a commission from qualified purchases from these link(s). For more information, see <router-link to="/privacy">Privacy Policy and Disclosure</router-link>.</div>
      <!-- <div class="mainAmazon"><slot name="amazon"></slot> </div> -->
      <div class="alternateAmazon mb-2 align-center" >              
        <div class="mb-3 item">
          <a :href="amazonURL">
            <img class="hidden-sm-and-up" :src="itemImage" style="width: 75%;"/>
            <img class="hidden-xs-only" :src="itemImage" />
          </a>
        </div>
        <div class="text-xs-center mt-4">
        <MusicButtons :buttons=buttons></MusicButtons>
        </div>
      </div>
  </div>
</template>

<script>
import MusicButtons from "./MusicButtons.vue";

export default {
  name: "MusicLink",
  props: {
    amazonURL: String,
    itemImage: String,
    buttons: Array
  },
  components: {
    MusicButtons
  },
};
</script>

<style>
.disclaimer{
  font-size: 10px;
  font-style: italic;
}

.linkText{
  font-weight: bolder;
  color:black;
  text-decoration: none;
  margin-bottom: 10px;
  /* box-shadow: 0px 0px 0px 1px orangered inset; */
}

.item img{
  box-shadow: 1px 10px 10px 1px black;
  /* width: 180px; */
  max-height: 500px;
  /* height: 100%; */
  max-width: 100%;
}

.linkOutside{
  display:block; 
  min-width: 0;
  margin-left:auto;
  margin-right:auto;
  max-width: 250px;
  margin: 5px 10px 5px 10px;
  /* width: 100%; */
  /* display:inline; */
  padding-top: 5px;
  font-size: 11px;
  width: 100%;
  max-width: 200px;
  margin: 0 auto;
}

</style>